import { apiRequest } from './auth';

export const rotationsAPI = {
  getAll: async () => {
    return await apiRequest('/rotations');
  },

  getByProject: async (project) => {
    return await apiRequest(`/rotations/project/${encodeURIComponent(project)}`);
  },

  getById: async (id) => {
    return await apiRequest(`/rotations/${id}`);
  },

  create: async (rotationData) => {
    return await apiRequest('/rotations', {
      method: 'POST',
      body: JSON.stringify(rotationData),
    });
  },

  update: async (id, rotationData) => {
    return await apiRequest(`/rotations/${id}`, {
      method: 'PUT',
      body: JSON.stringify(rotationData),
    });
  },

  delete: async (id) => {
    return await apiRequest(`/rotations/${id}`, {
      method: 'DELETE',
    });
  }
};

export default rotationsAPI;
